import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    Typography,
} from '@mui/material';
import { PiButton } from '@sensei/pi-component';
import { RoutesEnum } from '../../types/routes.enum';
import { useRouter } from 'next/router';
import useJoinWithoutInvitationDialogStyles from '../../styles/join-without-invitation-dialog/join-without-invitation-dialog.style';
import { useTranslation } from 'react-i18next';
import useAuth from '../../auth/use-auth';

export default function JoinWithoutInvitationDialog() {
    const { user } = useAuth();
    const [popupIsOpen, setPopupIsOpen] = useState(false);
    const classes = useJoinWithoutInvitationDialogStyles();
    const router = useRouter();
    const { t } = useTranslation();

    // Check if user connected to GMS
    useEffect(() => {
        if (
            user?.memberId &&
            user?.memberId === user?.membersPortalEmailAddress &&
            router.pathname !== RoutesEnum.BASE
        ) {
            setPopupIsOpen(true);
        }
    }, [user, router]);

    return (
        <Dialog open={popupIsOpen} fullWidth={true} maxWidth="sm">
            <DialogContent>
                <Typography variant="h4" className={classes.dialogContent}>
                    {t('joinWithoutInvitationDialog.title')}
                </Typography>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <PiButton
                    color="secondary"
                    onClick={() => router.push(RoutesEnum.LOGOUT)}
                >
                    {t('joinWithoutInvitationDialog.logoutButton')}
                </PiButton>
            </DialogActions>
        </Dialog>
    );
}
